import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';

import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideToastr } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';

import { KeycloakService } from 'keycloak-angular';
import { KeycloakHttpInterceptor } from './auth/keycloak.interceptor';
import { initializeKeycloak } from './auth/keycloak-init';

import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';

import { reducers, metaReducers } from './store';
import { environment } from '../environments/environment';

import { LicenseManager } from 'ag-grid-enterprise';

// AG Grid License
LicenseManager.setLicenseKey(environment.agGridLicenceKey);

export const appConfig: ApplicationConfig = {
  providers: [
    // 🔹 Angular core
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),

    // 🔹 ngx-bootstrap (ONLY PLACE FOR ModalModule)
    importProvidersFrom(
      ModalModule.forRoot()
    ),

    // 🔹 HTTP + Interceptors
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([KeycloakHttpInterceptor])
    ),

    // 🔹 Toastr
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),

    // 🔹 Keycloak
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },

    // 🔹 NgRx
    provideStore(reducers, { metaReducers }),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
      autoPause: true,
    }),
    provideEffects([]),
  ],
};
